import { render, staticRenderFns } from "./ToggleButtonStatus.vue?vue&type=template&id=01dc7968&"
import script from "./ToggleButtonStatus.vue?vue&type=script&lang=js&"
export * from "./ToggleButtonStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01dc7968')) {
      api.createRecord('01dc7968', component.options)
    } else {
      api.reload('01dc7968', component.options)
    }
    module.hot.accept("./ToggleButtonStatus.vue?vue&type=template&id=01dc7968&", function () {
      api.rerender('01dc7968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ToggleButtonStatus.vue"
export default component.exports